<div class="reportsPage prodAvailability">
  <div class="row">
    <div class="col-md-10">
      <h3>Grower Order Audit</h3>
    </div>
    <div class="col-md-2 text-right m-auto">
      <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
      <a href="Javascript:void(0);" style="color: #0b3f54; padding:20px;" (click)="selectFilter()">MANAGE REPORTS</a>
    </div>
  </div>
  <div class="form-sec productFilterDropDown">
    <div class="row margin-t20 margin-r0">
      <div class="col-sm-7 col-md-9 col-lg-10 smallPadRgt0">
        <div class="row search-box-outer">
          <div class="col-md-4 col-lg-3 padding-r0 borderRight padding-l0">
            <div class="category-dropdown material-select">
              <ng-select [items]="searchTypeList"
                         name="ddlProductSearch"
                         [(ngModel)]="selectedValue"
                         (ngModelChange)="enableDisableSearch()"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         bindValue="value"
                         labelForId="name"
                         [searchable]="false"
                         (change)="keepFilter()">
              </ng-select>
            </div>
          </div>
          <div class="col-md-8 col-lg-9 padding-l0 padding-r0">
            <div class="material-select reports-search-filter">
              <ng-select #productSearch name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                         [items]="orderNoList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.ItemNo"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <div class="search-box-outer" *ngIf="selectedValue === 'Order Number'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();" placeholder="Search..." type="text" [(ngModel)]="productFilters.OrderNo">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="search-box-outer" *ngIf="selectedValue === 'Change Quantity'">
                <div class="reports-search-filter padding-l0 d-flex">
                  <span class="compareDropdown">
                    <ng-select #select
                               [items]="comparisonType"
                               [(ngModel)]="filter.changeQtyAction"
                               [virtualScroll]="true"
                               [clearable]="false"
                               class="custom-select-grower"
                               [closeOnSelect]="true"
                               bindLabel="value"
                               bindValue="value">
                    </ng-select>
                  </span>
                  <div class="search-box-outer chnageQuantityInput margin-l10">
                    <div class="search-box wide90">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();" placeholder="Search..." type="text" [(ngModel)]="productFilters.ChangeQty">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-select #select name="ddlAccount" *ngIf="isEvolveAccountRestriction == true && selectedValue === 'Account'"
                         [items]="ddlAccounts"
                         [loading]="accountsLoading"
                         [(ngModel)]="productFilters.Account"
                         [virtualScroll]="true"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         (change)="keepFilter();"
                         (clear)="accountClear($event)"
                         class="custom-select-grower searchIcon lpSearch"
                         placeholder="Select Account"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn">

                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row" *ngIf="item.accountNumber!=-1">
                      <div class="col-md-8">
                        <h4 class="name" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="row" *ngIf="item.accountNumber==-1">
                      <div class="col-md-8">
                        <h4 class="name" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
                <ng-template ng-footer-tmp let-search="searchTerm">
                  <div class="custom-drop-footer">
                    <div class="row">
                      <div class="col-md-12">
                        Select an option above to filter
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <div class="search-box-outer" *ngIf="isEvolveAccountRestriction == false && selectedValue === 'Account No'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();" placeholder="Search..." type="text" [(ngModel)]="productFilters.AccountNo">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="search-box-outer" *ngIf="isEvolveAccountRestriction == false && selectedValue === 'Account Name'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter()" placeholder="Search..." type="text" [(ngModel)]="productFilters.AccountName">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-select *ngIf="selectedValue === 'Grower'"
                         name="ddlGrower"
                         [items]="growerList"
                         class="custom-select-grower searchIcon lpSearch"
                         [(ngModel)]="productFilters.Grower"
                         [virtualScroll]="true"
                         bindLabel="growerNameCityState"
                         placeholder="Select Grower"
                         [loading]="growerLoading"
                         bindValue="gmk"
                         [searchFn]="growerSearchFn"
                         [closeOnSelect]="true"
                         (change)="keepFilter()"
                         (search)="search($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.businessName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zip}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Grower GMK: {{item.gmk}}
                          </span>
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Grower GLN: {{item.growerGLN}}
                          </span>
                        </p>
                      </div>
                      <div class="col-md-3 orderId-detail text-right">
                        Order:
                        <p *ngIf="item.growerOrderList.length > 0">{{item.OrderNumber}}</p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
                <ng-template ng-footer-tmp let-search="searchTerm">
                  <div class="custom-drop-footer">
                    <div class="row">
                      <div class="col-md-4 bold text-left">
                        Results : {{searchCount}}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>

              <div class="search-box-outer" *ngIf="isEvolveAccountRestriction == false && selectedValue === 'Grower Name'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter()" placeholder="Search..." type="text" [(ngModel)]="productFilters.GrowerName">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="selectedValue=='City'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter()" placeholder="Search..." type="text" [(ngModel)]="productFilters.City">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div #productSearch *ngIf="selectedValue === 'Product Name'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="getGrowerOrderAuditLog()" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateBrandSearch()"
                             placeholder="Search..." type="text">
                    </div>
                  </div>
                </div>
              </div>

              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Marketing Brand'"
                         [items]="marketingMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.MarketingBrandList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Seed Size'"
                         [items]="seedsizeMasterList"
                         placeholder="Search..."
                         [multiple]="true"
                         [hideSelected]="true"
                         class="custom-select-grower"
                         [(ngModel)]="productFilters.SeedSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Package Size'"
                         [items]="packagesizeMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.PackageSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <div class="search-box-outer" *ngIf="isEvolveAccountRestriction == false && selectedValue === 'Technology'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();" placeholder="Search..." type="text" [(ngModel)]="productFilters.Technology">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Treatment'"
                         [items]="treatmentMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.TreatmentList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Product Line'"
                         [items]="productLineMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.ProductLineList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <div class="col-md-6 maturitySelect padding-l0 padding-r0" *ngIf="selectedValue === 'Maturity'">
                <ng-select #productSearch name="ddlproductSearch"
                           [items]="maturityMasterList"
                           placeholder="Min"
                           class="custom-select-grower "
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.MaturityMin"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
              </div>

              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Duration'">
                <div class="text-center deliveryDatePicker">
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromDateFilter"
                           readonly [(ngModel)]="productFilters.FromDate" (dateChange)="keepFilter();validateDateFilter('fromDate', $event);">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Duration'">
                <div class="text-center deliveryDatePicker">
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toDateFilter"
                           readonly [(ngModel)]="productFilters.ToDate" (dateChange)="keepFilter();validateDateFilter('toDate', $event);">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-6 maturitySelect padding-l0 padding-r0" *ngIf="selectedValue === 'Maturity'">
                <ng-select #productSearch name="ddlproductSearch"
                           [items]="maturityMasterList"
                           placeholder="Max"
                           class="custom-select-grower"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.MaturityMax"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-5 col-md-3 col-lg-2 search-btn-outer text-right padding-l20 padding-r0">
        <div class="row">
          <div class="col-sm-6 padding-r15">
            <div class="search-btn">
              <button mat-raised-button class="btns" color="primary" (click)="getGrowerOrderAuditLog()">Search</button>
            </div>
          </div>
          <div class="col-sm-6 padding-r15">
            <div class="search-btn">
              <button mat-raised-button class="btns" color="primary" (click)="onExportBtnClick()" [disabled]="growerAuditDataSource?.data.length <= 0">Export</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 col-lg-10 text-right margin-t5">
        <span *ngIf="showHybridVarietyPackageSize">
          Is Hybrid Variety Package Size
          <mat-checkbox class="custom-checkbox margin-l10 margin-r20"
                        [checked]="filter.isHybridVarietyPackageSize === true"
                        (change)="filter.isHybridVarietyPackageSize = $event.checked ? true : null">
          </mat-checkbox>
        </span>
        <span *ngIf="showReservationConversion">
          Is Reservation Conversion
          <mat-checkbox class="custom-checkbox margin-l10 margin-r20"
                        [checked]="filter.isReservationConversion === true"
                        (change)="filter.isReservationConversion = $event.checked ? true : null">
          </mat-checkbox>
        </span>
        Do not display records with a change quantity of 0
        <mat-checkbox class="custom-checkbox margin-l10" [(ngModel)]="filter.includeChangeQtyZero"></mat-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 padding-r0">
        <div class="chips-sec">
          <div class="row selected-chip">
            <div class="col-sm-9 col-md-10 padding-l0">
              <div>
                <mat-chip-set>
                  <mat-chip selected *ngFor="let filterValue of filterValueList">
                    {{filterValue}}
                    <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                      <i class="fas fa-times text-right"></i>
                    </a>
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
            <div class="col-sm-3 col-md-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
              <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 padding-l30 padding-r0 padding-b10 padding-t10">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-9 padding-r30 padding-l0 text-left">
              <div class="row">
                <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                  <p *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                </div>
                <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                  <p *ngIf="currentFilter.filterDescription">
                    LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                  </p>
                </div>
                <div class="col-sm-3 col-md-3 padding-r30">
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription">Edit Report</button>
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription">Save</button>
                </div>
              </div>
            </div>
            <div class="col-sm-3 col-md-3 text-right">
              <div class="padding-r0 ">
                <button mat-raised-button class="btns" color="primary" (click)="addFilter()">Create Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="fulfill-top-sec">
        <div class="row listing-action-items">
          <div class="col-xl-4 col-lg-4 col-md-4">
          </div>
          <div class="col-xl-8 col-lg-8 col-md-8 text-right">
            <mat-paginator #productPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
          </div>
        </div>
      </div>
      <div class="tableContainer">
        <div class="tableComponentOuter">
          <table mat-table #productTable [dataSource]="growerAuditDataSource" matSort matSortDirection="desc" class="matTables productTable resultTable tableComponentInner mat-table">

            <ng-container matColumnDef="auditDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('auditDate').className">{{getColum('auditDate').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.auditTime | date:'MM-dd-yyyy'}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="auditTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('auditTime').className">{{getColum('auditTime').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.auditTime | date:'h:mm:ss a'}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="growerName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('growerName').className">{{getColum('growerName').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.growerName}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="growerGMK">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('growerGMK').className">{{getColum('growerGMK').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.growerGMK}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="growerGLN">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('growerGLN').className">{{getColum('growerGLN').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.growerGLN}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('orderNumber').className">{{getColum('orderNumber').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.orderNumber}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="accountNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('accountNumber').className">{{getColum('accountNumber').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.accountNumber}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('city').className">{{getColum('city').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.city}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="itemDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('itemDescription').className">{{getColum('itemDescription').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="order-info ">
                <p>{{element.brand}} - {{element.marketingBrand}} <span *ngIf="element.b2B" class="erp-order"><i title="B2B" class="fas fa-lock"></i></span></p>
                <p class="grower-name">
                  {{element.itemDescription}}
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="customerPO">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('customerPO').className">{{getColum('customerPO').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.customerPO}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="seller">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('seller').className">{{getColum('seller').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.seller}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="explanation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('explanation').className">{{getColum('explanation').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.explanation}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('action').className">{{getColum('action').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.action}}</p>
              </td>
            </ng-container>
            <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('quantity').className">{{getColum('quantity').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{commonService.getFormatedNumber(element.quantity) | number}}</p>
              </td>
            </ng-container>
            <ng-container matColumnDef="changeQty">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('changeQty').className">{{getColum('changeQty').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{commonService.getFormatedNumber(element.changeQty) | number}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="updatedBy">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('updatedBy').className">{{getColum('updatedBy').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="product-line text-center">
                <span>
                  {{element.updatedBy}}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="isHybridVarietyPackageSize">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('isHybridVarietyPackageSize').className">{{getColum('isHybridVarietyPackageSize').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.isHybridVarietyPackageSize}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="isReservationConversion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="getColum('isReservationConversion').className">{{getColum('isReservationConversion').headertxt}}</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <p>{{element.isReservationConversion}}</p>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="growerAuditDataSource == undefined || growerAuditDataSource?.data.length == 0" class="noDataMsg growerAudit">
            <p>No Record Found.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
